import Vue from 'vue'
import App from './App.vue'
import router from './router'

// Import Bootstrap (Vue CLI 3 style, see https://bootstrap-vue.org/docs and search for "Vue CLI 3") and all application specific customization overrides
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth_config.json";

// Import the Auth0 plugin here
import { Auth0Plugin } from "./auth";

// The 3rd party component that displays pictures
//import VuePictureSwipe from "vue-picture-swipe";
//Vue.component('vue-picture-swipe', VuePictureSwipe);

// This is a store for global variables. Values in this store
// can be accessed from all components. 
export var globalStore = new Vue({
  data: {
    mobileMode: false
  }
})

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience,
  onRedirectCallback: appState => {
    // Callback som anropas direkt efter lyckad Auth0-login.
    alert("Lyckad login: ott=" + $route.query.ott);
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : "" //window.location.pathname
    );
  }
});

// Bootstrap needs to be registered before the app is started
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App),
  el: '#app'
}).$mount('#app')
